import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Help extends PureComponent {

  static propTypes = {
    active: PropTypes.bool,
    tab: PropTypes.object,
  }

  componentDidMount() {
    const { tab } = this.props;
    if (tab.extra.didMount) {
      tab.extra.didMount();
    }
  }

  componentWillUnmount() {
    const { tab } = this.props;
    if (tab.extra.closeAction) {
      tab.extra.closeAction();
    }
  }

  activeClassName = 'is-active'

  render() {
    const { tab: { key: liveKey }, active } = this.props;
    const className = `gmTabs__panel ${(active) ? this.activeClassName : ''}`;
    return (
      <div className={className}>
        <div id={liveKey} />
      </div>
    );
  }

}

export default Help;
